import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles } from 'tss-react/mui';
import { getConf } from '@jbrowse/core/configuration';
import { ResizeHandle } from '@jbrowse/core/ui';
const useStyles = makeStyles()({
    resizeHandle: {
        height: 5,
        position: 'absolute',
        zIndex: 2,
    },
});
const AlignmentsDisplay = observer(function AlignmentsDisplay({ model, }) {
    var _a;
    const { PileupDisplay, SNPCoverageDisplay } = model;
    const { classes } = useStyles();
    if (!SNPCoverageDisplay) {
        return null;
    }
    const top = (_a = SNPCoverageDisplay.height) !== null && _a !== void 0 ? _a : 100;
    return (React.createElement("div", { "data-testid": `display-${getConf(model, 'displayId')}`, style: { position: 'relative' } },
        React.createElement("div", { "data-testid": "Blockset-snpcoverage" },
            React.createElement(SNPCoverageDisplay.RenderingComponent, { model: SNPCoverageDisplay })),
        React.createElement(ResizeHandle, { onDrag: delta => {
                SNPCoverageDisplay.setHeight(SNPCoverageDisplay.height + delta);
                return delta;
            }, className: classes.resizeHandle, style: { top: top - 4 } }),
        React.createElement("div", { "data-testid": "Blockset-pileup", style: {
                position: 'absolute',
                top,
            } },
            React.createElement(PileupDisplay.RenderingComponent, { model: PileupDisplay }))));
});
export default AlignmentsDisplay;
